import axios from "axios";

function CustomersService() {
    let controller = null;
    const init = () => controller = new AbortController();
    const dispose = () => { if (controller) controller.abort(); controller = null; };
    const config = () => controller && controller.signal ? { signal: controller.signal } : null;

    const get = () => axios
        .get('/customers', config())
        .catch(error => error);

    return {
        init,
        dispose,
        get
    };
}

export default CustomersService;